import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import arrowRightWhite from "@/assets/images/console/arrowRightWhite.svg";
import icMenuBoard from "@/assets/images/console/icMenuBoard.svg";
import icMenuDesign from "@/assets/images/console/icMenuDesign.svg";
import { ScrollArea } from "@/components/ui/scroll-area";

export const menuConfig = [
    {
        title: "게시판 관리",
        menuId: "board",
        urlPrefix: "/console/board/",
        subItems: [
            { path: "166", label: "공지사항", id: "board1" },
            { path: "171", label: "관련자료", id: "board2" },
            { path: "167", label: "자주 묻는 질문", id: "board3" },
            { path: "170", label: "인스타그램", id: "board4" },
        ],
    },
    {
        title: "디자인 관리",
        menuId: "design",
        urlPrefix: "/console/design/",
        subItems: [{ path: "popup", label: "팝업 관리", id: "design1" }],
    },
];

export default function Nav() {
    const location = useLocation();
    const [menuOn, setMenuOn] = useState<string | null>(null);

    useEffect(() => {
        const path = location.pathname;
        const menuMapping: { [key: string]: string } = {
            "/console/board/166": "board1",
            "/console/board/171": "board2",
            "/console/board/167": "board3",
            "/console/board/170": "board4",
            "/console/design/popup": "design1",
        };

        // 정확한 경로 일치를 우선으로 검사
        const newMenuOn =
            Object.keys(menuMapping).find(key => path === key) ||
            Object.keys(menuMapping).find(key => path.startsWith(key));

        if (newMenuOn) {
            setMenuOn(menuMapping[newMenuOn]);
        } else {
            setMenuOn("");
        }
    }, [location]);

    return (
        <div className="fixed inset-0 h-full w-[360px] bg-[#192030]">
            <div className="flex h-[80px] items-center justify-center shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]">
                <Link to="/console/board/166" className="text-[40px] font-[600] text-white">
                    관리자
                </Link>
            </div>
            <ScrollArea className="h-[calc(100%-80px)] py-[30px]">
                <ul className="px-[20px]">
                    {menuConfig.map((menu, i) => (
                        <li key={`menu_${i}`}>
                            <button
                                type="button"
                                className={`flex w-full items-center justify-between rounded-[5px] p-[16px_12px] text-[22px] font-[600] text-white${menuOn?.includes(menu.menuId) ? " bg-[rgba(255,255,255,0.1)]" : ""}`}
                                onClick={() => {
                                    if (menuOn?.includes(menu.menuId)) {
                                        setMenuOn(null);
                                    } else {
                                        setMenuOn(menu.menuId);
                                    }
                                }}
                            >
                                <p className="flex items-center gap-[12px]">
                                    <img src={i === 0 ? icMenuBoard : icMenuDesign} alt="아이콘" />
                                    <span>{menu.title}</span>
                                </p>
                                <img src={arrowRightWhite} alt="화살표" />
                            </button>
                            {menuOn?.includes(menu.menuId) && (
                                <ul className="py-[10px]">
                                    {menu.subItems.map((subMenu, j) => (
                                        <li key={`sub_menu_${j}`}>
                                            <Link
                                                to={`${menu.urlPrefix}${subMenu.path}`}
                                                className={`block p-[10px_0_10px_48px] text-[20px] font-[500] text-[rgba(255,255,255,0.8)] ${menuOn === subMenu.id ? " underline" : ""}`}
                                            >
                                                {subMenu.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </ScrollArea>
        </div>
    );
}
